import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import {
  FindCampaignGroupsQuerySchema,
  FindCampaignGroupsRequestSchema,
  FindCampaignGroupsResponseSchema,
  GetCampaignGroupByIdParamsSchema,
  GetCampaignGroupByIdRequestSchema,
  GetCampaignGroupByIdResponseSchema,
  GetCampaignGroupsQuerySchema,
  GetCampaignGroupsRequestSchema,
  GetCampaignGroupsResponseSchema,
  GetCampaignGroupsStatusSummaryRequestSchema,
  GetCampaignGroupsStatusSummaryResponseSchema,
} from './schemas.ts'

const c = initContract()

const BASE = '/flight-deck/v1/campaigns'

export const campaignsContract = c.router(
  {
    list: c.query({
      method: 'GET',
      path: BASE,
      description: 'Get campaign groups',
      query: GetCampaignGroupsQuerySchema,
      request: GetCampaignGroupsRequestSchema,
      responses: {
        200: GetCampaignGroupsResponseSchema,
      },
    }),
    statusSummary: c.query({
      method: 'GET',
      path: `${BASE}/status-summary`,
      description: 'Get campaign group status summary',
      query: GetCampaignGroupsQuerySchema,
      request: GetCampaignGroupsStatusSummaryRequestSchema,
      responses: {
        200: GetCampaignGroupsStatusSummaryResponseSchema,
      },
    }),
    findCampaignGroups: c.query({
      method: 'GET',
      path: `${BASE}/find`,
      description: 'Find campaign groups',
      query: FindCampaignGroupsQuerySchema,
      request: FindCampaignGroupsRequestSchema,
      responses: {
        200: FindCampaignGroupsResponseSchema,
      },
    }),
    getById: c.query({
      method: 'GET',
      path: `${BASE}/:campaignGroupId`,
      description: 'Get a campaign group by ID',
      pathParams: GetCampaignGroupByIdParamsSchema,
      request: GetCampaignGroupByIdRequestSchema,
      responses: {
        200: GetCampaignGroupByIdResponseSchema,
        404: ErrorResponseSchema,
      },
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Flight Deck'] },
  },
)

export type CampaignsContract = typeof campaignsContract

export type {
  CampaignGroup,
  GetCampaignGroupsStatusSummaryResponse,
} from './schemas.ts'
